import { z } from 'zod/v4'

const userSchema = z.object({
  id: z.coerce.number(),
  name: z.string().optional().or(z.literal('')),
  email: z.string().optional().or(z.literal('')).nullable(),
  phone: z.string().optional().or(z.literal('')).nullable(),
  type: z.string().optional().or(z.literal('')).nullable(),
});

export const supplierValidation = () => {
  return z.object({
    name: z.string().min(1, { message: 'Form is required' }),
    total_product: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    address: z.string().optional().nullable().or(z.literal('')),
    website: z.string().min(1, { message: 'Form is required' }).url('invalid URL Format'),
    users: z
      .array(userSchema)
      .transform((val) => {
        if (val.length > 0) {
          return val
        }
        return []
    }),
    country_id: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    province_id: z.string().nullable(),
    city_id: z.string().nullable(),
    district_id: z.string().nullable(),
    settings: z.array(z.string()),
    acronim_name: z.string().optional().or(z.literal('')),
    invitation_code: z.string().optional().or(z.literal('')),
    featured: z.boolean(),
    active: z.boolean(),
    group_link: z.string().url('invalid URL Format').optional().or(z.literal('')).nullable(),
    biography: z.string().optional().or(z.literal('')),
    refund_policy: z.string().optional().or(z.literal('')),
    warranty_policy: z.string().optional().or(z.literal('')),
    purchase_note: z.string().optional().or(z.literal('')),
    currency: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    minimum_order: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    pic_name: z.string().optional().or(z.literal('')).nullable(),
    pic_email: z.string().email('invalid email format').optional().or(z.literal('')).nullable(),
    pic_phone: z.string().optional().or(z.literal('')).nullable(),
    slug: z.string().min(1, { message: 'Form is required' }),
    is_enable_discount: z.boolean(),
    discount_minimum_spend: z.coerce.number().optional().nullable(),
    discount_type: z.string().min(1, { message: 'Form is required' }),
    discount_amount: z.coerce.number().optional().nullable(),
    discount_cities: z.array(z.coerce.number().optional()),
    logo_encoded: z.string().optional().nullable(),
  }).refine(
    (data) => {
      if (data.is_enable_discount) {
        return data.discount_minimum_spend !== null
      }
      return true
    },
    {
      message: 'form is required',
      path: ['discount_minimum_spend'],
    }
  ).refine(
    (data) => {
      if (data.is_enable_discount) {
        return data.discount_amount !== null
      }
      return true
    },
    {
      message: 'form is required',
      path: ['discount_amount'],
    }
  ).refine(
    (data) => {
      if (data.is_enable_discount) {
        return data.discount_type !== null
      }
      return true
    },
    {
      message: 'form is required',
      path: ['discount_type'],
    }
  ).refine(
    (data) => {
      if (data.is_enable_discount) {
        return data.discount_cities.length > 0
      }
      return true
    },
    {
      message: 'form is required',
      path: ['discount_cities'],
    }
  )
}

export const clientSupplierValidation = () => {
  return z.object({
    id: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    type: z.string().min(1, { message: 'Form is required' }),
  })
}